import { Shield, Wrench, Calendar, Award, MessagesSquare, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: Shield, title: "Licensed & Insured", text: "Full coverage and credentials available on request — peace of mind, baked in." },
  { icon: Wrench, title: "Professional Crews", text: "Specialists for ADU, plumbing, HVAC, drywall and remodeling. Right tool, right person." },
  { icon: Calendar, title: "Reliable Scheduling", text: "We show up on time, communicate clearly and respect your home every day on site." },
  { icon: Award, title: "Quality Materials", text: "We don't cut corners. Everything we install is built to last and easy to maintain." },
  { icon: MessagesSquare, title: "Honest Communication", text: "Plain-language quotes, no surprises. You always know where the project stands." },
  { icon: BadgeCheck, title: "Competitive Pricing", text: "Fair pricing for quality work — and financing options for qualifying projects." },
];

export default function WhyChooseUs() {
  return (
    <section data-testid="why-us-section" className="section-pad bg-white border-y border-brand-line">
      <div className="container-page">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <p className="overline mb-3">Why ME Builders</p>
            <h2 className="heading-2">Built on reliability, clean craftsmanship and customer satisfaction.</h2>
          </div>
          <div className="md:col-span-7 md:pt-8">
            <p className="body-base">
              Every project matters — whether it's a simple plumbing repair, an HVAC tune-up, or a complete ADU build from the ground up. Our mission is simple: deliver quality work, honest service, and long-lasting results.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-brand-line border border-brand-line rounded-md overflow-hidden">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} data-testid={`why-item-${i}`} className="bg-white p-8 hover:bg-brand-bone transition-colors">
                <Icon className="w-6 h-6 text-brand-olive" strokeWidth={1.5} />
                <h3 className="heading-3 mt-5">{it.title}</h3>
                <p className="body-sm mt-2">{it.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
